import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import config from 'utils/config';

// The app id for our heap analytics account
var appid = '1831778886';
// The settings that we want for our account
var settings = {
  secureCookie: true
};
var events = ['addEventProperties', 'addUserProperties', 'clearEventProperties', 'identify', 'resetIdentity', 'removeEventProperty', 'setEventProperties', 'track', 'unsetEventProperty'];
function createEvents(e) {
  return function () {
    // eslint-disable-next-line prefer-rest-params
    window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
  };
}
function setHeapIdentity(_ref) {
  var userId = _ref.userId,
    domain = _ref.domain,
    domainId = _ref.domainId;
  window.heap.identify("".concat(domainId, "-").concat(userId));
  window.heap.addUserProperties({
    domain: domain
  });
}
export function addHeapTracking(_x) {
  return _addHeapTracking.apply(this, arguments);
}
function _addHeapTracking() {
  _addHeapTracking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var _window;
    var userId, domain, domainId, i, _firstScript$parentNo, newScript, firstScript;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = _ref2.userId, domain = _ref2.domain, domainId = _ref2.domainId;
          (_window = window).heap || (_window.heap = []);
          window.heap.appid = appid;
          window.heap.config = settings;
          if (!window.heap.loaded) {
            _context.next = 1;
            break;
          }
          setHeapIdentity({
            userId: userId,
            domain: domain,
            domainId: domainId
          });
          return _context.abrupt("return");
        case 1:
          if (!(window.heap.loaded === null)) {
            _context.next = 2;
            break;
          }
          window.heap.loaded = true;
          setHeapIdentity({
            userId: userId,
            domain: domain,
            domainId: domainId
          });
          return _context.abrupt("return");
        case 2:
          for (i = 0; i < events.length; i++) window.heap[events[i]] = createEvents(events[i]);

          // add the script to the page if it doesn't already exist
          if (!document.getElementById('heapScript')) {
            newScript = document.createElement('script');
            newScript.type = 'text/javascript';
            newScript.async = true;
            newScript.src = "https://cdn.heapanalytics.com/js/heap-".concat(appid, ".js");
            newScript.id = 'heapScript';
            newScript.addEventListener('load', function () {
              setHeapIdentity({
                userId: userId,
                domain: domain,
                domainId: domainId
              });
            });
            firstScript = document.getElementsByTagName('script')[0];
            (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.insertBefore(newScript, firstScript);
          }
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _addHeapTracking.apply(this, arguments);
}
export function removeHeapTracking() {
  var _window$heap;
  if (!((_window$heap = window.heap) !== null && _window$heap !== void 0 && _window$heap.loaded)) return;
  window.heap.resetIdentity();
  // setting loaded to null will stop heap from tracking the user
  window.heap.loaded = null;
}
/**
 * add the Heap.io tracking script to the page if the user is an admin but not a super user and if the tracking config is enabled
 * @param {object} object - data object
 * @param {number} object.userId - current user
 * @param {string} object.domain - domain url to be logged in Heap
 * @param {number} object.domainId - domain.id
 * @param {boolean} object.isAdmin - is the current user an admin. Only admins are tracked
 * @param {object} object.role - used to find if user is super user who aren't tracked
 */
export function addHeapTrackingIfRequired(_ref3) {
  var userId = _ref3.userId,
    domain = _ref3.domain,
    domainId = _ref3.domainId,
    isAdmin = _ref3.isAdmin,
    role = _ref3.role;
  if (isAdmin && !role.super && config.enableTracking) {
    addHeapTracking({
      userId: userId,
      domain: domain,
      domainId: domainId
    });
  } else {
    removeHeapTracking();
  }
}